export const heroSlides = [
  {
    id: "slide-1",
    title: "Uninterrupted Communication",
    subtitle: "Anywhere, Anytime",
    description: "Delivering crystal-clear audio, extended range coverage, and military-grade durability for professionals worldwide.",
    cta: "Explore Products",
    ctaLink: "/products",
    image: "https://readdy.ai/api/search-image?query=Large%20industrial%20logistics%20warehouse%20and%20distribution%20center%20workers%20wearing%20safety%20vests%20using%20two-way%20walkie-talkie%20radios%20to%20coordinate%20operations%20professional%20wide%20angle%20photography%20dramatic%20lighting%20high%20quality%20modern%20facility%20interior%20with%20conveyor%20belts%20and%20shelving%20blue%20and%20green%20color%20tones&width=1400&height=800&seq=51&orientation=landscape",
  },
  {
    id: "slide-2",
    title: "Built for the Field",
    subtitle: "Rugged & Reliable",
    description: "IP68 waterproof, dustproof, and shockproof two-way radios that survive the toughest industrial environments.",
    cta: "View Solutions",
    ctaLink: "/solutions",
    image: "https://readdy.ai/api/search-image?query=Construction%20site%20workers%20using%20walkie-talkie%20two-way%20radios%20communicating%20on%20industrial%20building%20site%20with%20cranes%20and%20steel%20structures%20blue%20safety%20helmets%20and%20vests%20dramatic%20lighting%20professional%20photography%20wide%20angle&width=1400&height=800&seq=100&orientation=landscape",
  },
  {
    id: "slide-3",
    title: "Secure Team Coordination",
    subtitle: "Encrypt & Connect",
    description: "Military-grade encryption keeps your sensitive communications private and protected from unauthorized access.",
    cta: "Get In Touch",
    ctaLink: "/contact",
    image: "https://readdy.ai/api/search-image?query=Security%20team%20and%20event%20management%20professionals%20using%20professional%20two-way%20radios%20in%20large%20outdoor%20venue%20coordinating%20operations%20blue%20and%20green%20color%20tones%20professional%20photography%20wide%20angle%20team%20communication&width=1400&height=800&seq=101&orientation=landscape",
  },
];

export const homeData = {
  hero: {
    title: "Uninterrupted Communication",
    subtitle: "Anywhere, Anytime",
    description: "Trusted by 500+ Industry Leaders",
    cta: "Explore Products",
  },
  about: {
    tag: "About Us",
    title: "Pioneering Wireless Communication Since 2005",
    stats: [
      { number: "18+", label: "Years of Experience" },
      { number: "500+", label: "Enterprise Clients" },
      { number: "50K", label: "Devices Deployed" },
      { number: "99.9%", label: "Uptime Reliability" },
    ],
    features: [
      "Crystal-clear audio quality across all terrains",
      "Military-grade durability and weatherproofing",
      "Extended battery life for 24/7 operations",
      "Secure encrypted channels for sensitive communications",
    ],
  },
  products: {
    tag: "View All",
    title: "Professional Grade Two-Way Radios",
    items: [
      {
        id: "ht-900",
        name: "HT-900 Pro",
        spec: "VHF 136-174 MHz / 10W",
        image: "https://readdy.ai/api/search-image?query=Professional%20walkie-talkie%20two-way%20radio%20device%20isolated%20on%20clean%20white%20background%20with%20subtle%20shadow%20modern%20sleek%20design%20black%20and%20dark%20blue%20color%20scheme%20high%20quality%20product%20photography%20studio%20lighting&width=600&height=600&seq=1&orientation=squarish",
      },
      {
        id: "ht-700",
        name: "HT-700 Rugged",
        spec: "UHF 400-470 MHz / 8W",
        image: "https://readdy.ai/api/search-image?query=Heavy-duty%20rugged%20walkie-talkie%20two-way%20radio%20device%20with%20antenna%20isolated%20on%20clean%20white%20background%20industrial%20design%20green%20accent%20color%20high%20quality%20product%20photography%20studio%20lighting&width=600&height=600&seq=2&orientation=squarish",
      },
      {
        id: "ht-500",
        name: "HT-500 Compact",
        spec: "UHF 400-470 MHz / 5W",
        image: "https://readdy.ai/api/search-image?query=Compact%20small%20walkie-talkie%20two-way%20radio%20device%20pocket%20size%20isolated%20on%20clean%20white%20background%20modern%20minimalist%20design%20light%20blue%20color%20high%20quality%20product%20photography%20studio%20lighting&width=600&height=600&seq=3&orientation=squarish",
      },
      {
        id: "ht-300",
        name: "HT-300 Entry",
        spec: "UHF 400-470 MHz / 3W",
        image: "https://readdy.ai/api/search-image?query=Entry-level%20walkie-talkie%20two-way%20radio%20device%20simple%20design%20isolated%20on%20clean%20white%20background%20affordable%20professional%20radio%20light%20green%20color%20high%20quality%20product%20photography%20studio%20lighting&width=600&height=600&seq=4&orientation=squarish",
      },
    ],
  },
  features: {
    tag: "Our Tech",
    title: "Built for Performance in Every Environment",
    items: [
      {
        title: "Noise Cancellation",
        description: "AI-powered noise suppression for clear audio in noisy environments.",
        metric: "98%",
        image: "https://readdy.ai/api/search-image?query=Professional%20audio%20noise%20cancellation%20technology%20concept%20visualization%20sound%20waves%20being%20filtered%20modern%20digital%20illustration%20blue%20and%20green%20color%20scheme%20clean%20minimal%20design%20technology%20background&width=600&height=400&seq=5&orientation=squarish",
      },
      {
        title: "Long Range Coverage",
        description: "Extended range up to 35km in open terrain with optimal antenna.",
        metric: "35km",
        image: "https://readdy.ai/api/search-image?query=Radio%20signal%20coverage%20range%20concept%20wide%20open%20landscape%20with%20radio%20towers%20broadcasting%20signals%20modern%20illustration%20blue%20and%20green%20color%20scheme%20clean%20minimal%20design%20technology%20background&width=600&height=400&seq=6&orientation=squarish",
      },
      {
        title: "24h Battery Life",
        description: "High-capacity lithium battery ensures uninterrupted communication.",
        metric: "24h",
        image: "https://readdy.ai/api/search-image?query=Battery%20power%20energy%20concept%20modern%20illustration%20with%20power%20indicator%20lithium%20battery%20technology%20visualization%20blue%20and%20green%20color%20scheme%20clean%20minimal%20design%20technology%20background&width=600&height=400&seq=7&orientation=squarish",
      },
      {
        title: "IP68 Waterproof",
        description: "Fully waterproof and dustproof for extreme weather conditions.",
        metric: "IP68",
        image: "https://readdy.ai/api/search-image?query=Waterproof%20technology%20concept%20water%20droplets%20bouncing%20off%20surface%20modern%20illustration%20blue%20and%20green%20color%20scheme%20clean%20minimal%20design%20technology%20background%20water%20resistance&width=600&height=400&seq=8&orientation=squarish",
      },
    ],
  },
  cta: {
    title: "Connect Without Limits",
    subtitle: "Ready to transform your team communication?",
    button: "Get In Touch",
    bgImage: "https://readdy.ai/api/search-image?query=Modern%20communication%20tower%20with%20antennas%20at%20sunset%20dramatic%20sky%20blue%20and%20green%20color%20tones%20professional%20photography%20industrial%20technology%20infrastructure%20high%20quality&width=1400&height=800&seq=9&orientation=landscape",
  },
  testimonials: {
    title: "What Clients Say",
    rating: "4.9",
    items: [
      {
        quote: "Huatera radios transformed our construction site coordination. The range and clarity are unmatched, and our teams stay connected across 12 floors effortlessly.",
        name: "Michael Chen",
        role: "Project Manager, Apex Construction",
        avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20an%20Asian%20male%20construction%20manager%20wearing%20hard%20hat%20and%20safety%20vest%20confident%20smile%20clean%20background%20professional%20photography&width=100&height=100&seq=10&orientation=squarish",
      },
      {
        quote: "We deployed 200 units across our logistics fleet. The battery life is exceptional, and the waterproof design handles any weather condition. Highly recommended!",
        name: "Sarah Williams",
        role: "Operations Director, FastTrack Logistics",
        avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20Caucasian%20female%20logistics%20director%20business%20professional%20attire%20confident%20smile%20clean%20office%20background%20professional%20photography&width=100&height=100&seq=11&orientation=squarish",
      },
      {
        quote: "The encryption and security features give us peace of mind for our event communications. Huatera is now our go-to partner for all large-scale events.",
        name: "James Rodriguez",
        role: "Event Coordinator, Summit Events",
        avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20Hispanic%20male%20event%20coordinator%20business%20casual%20attire%20confident%20smile%20clean%20background%20professional%20photography&width=100&height=100&seq=12&orientation=squarish",
      },
    ],
  },
  footer: {
    brand: "Huatera",
    tagline: "Quanzhou Shijia Rongyan Electronic Technology Co, Ltd.",
    links: {
      title: "Quick Links",
      items: ["Home", "About", "Products", "Solutions", "News", "Contact"],
    },
    contact: {
      title: "Contact Us",
      phone: "+86 137 8885 5889\n+86 159 9998 9668",
      email: "huatera88@gmail.com",
      address: "Gangwu (Chenghui International), Qiuzhong Village, Xiamei Town\nNan'an City, Fujian Province",
    },
    social: [
      { name: "Website", url: "https://www.huatera.com" },
      { name: "Email", url: "mailto:huatera88@gmail.com" },
    ],
    copyright: "2026 Quanzhou Shijia Rongyan Electronic Technology Co, Ltd. All rights reserved.",
    legal: ["Privacy Policy", "Terms of Service"],
  },
};